import { ToastContext } from '../context/ToastContext';

import { useContext } from 'react';

export const useToast = () => {
  const { toast } = useContext(ToastContext);
  return { toast };
};
